import React from 'react';
import { createRoot } from 'react-dom/client';
import CartContext from './cart-context';
import Cart from './cart';

export default (element, data) => {
  const renderCart = () => {
    const root = createRoot(element);
    root.render(
      <CartContext data={data}>
        <Cart />
      </CartContext>,
    );
  };

  const init = () => {
    renderCart();
  };

  init();
};
